import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  list: {
    width: 200,
    height: 230,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
}));

function not(a, b) {
  const target = [];
  a.forEach((avalue) => {
    const existTarget = b.filter((bvalue) => bvalue.value === avalue.value);
    if (existTarget.length === 0) {
      target.push(avalue);
    }
  });
  return target;
}

function intersection(a, b) {
  let target = [];
  a.forEach((avalue) => {
    const existTarget = b.filter((bvalue) => bvalue.value === avalue.value);
    if (existTarget.length > 0) {
      target = target.concat(existTarget);
    }
  });
  return target;
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

function isChecked(targets, item) {
  return targets.some((target) => target.value === item.value);
}

export default function TransferList(props) {
  const classes = useStyles();
  const [checked, setChecked] = React.useState([]);
  const { right, left } = props;

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (item) => () => {
    const isExist = checked.some((target) => target.value === item.value);
    let newChecked = [...checked];

    if (!isExist) {
      newChecked.push(item);
    } else {
      newChecked = checked.filter((target) => target.value !== item.value);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    const tempRight = right.concat(leftChecked);
    const tempLeft = not(left, leftChecked);
    props.onSetValue(tempRight, tempLeft);
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    const tempLeft = left.concat(rightChecked);
    const tempRight = not(right, rightChecked);
    props.onSetValue(tempRight, tempLeft);
    setChecked(not(checked, rightChecked));
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={(
          <Checkbox
            color="primary"
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length
              && numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        )}
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} 選択中`}
      />
      <Divider />
      <List
        className={classes.list}
        dense
        component="div"
        role="list"
      >
        {items.map((item) => {
          const labelId = `transfer-list-all-item-${item.value}-label`;

          return (
            <ListItem
              key={item.value}
              role="listitem"
              button
              onClick={handleToggle(item)}
            >
              <ListItemIcon>
                <Checkbox
                  color="primary"
                  checked={isChecked(checked, item)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={item.label} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center" className={classes.root}>
      <Grid item>{customList(props.leftTitle, left)}</Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            className={classes.button}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            className={classes.button}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>{customList(props.rightTitle, right)}</Grid>
    </Grid>
  );
}
